import React from 'react'
import classNames from 'classnames'

import { createStyles, withStyles, WithStyles, Theme } from '@material-ui/core/styles'

import Grid, { GridProps } from '@material-ui/core/Grid'

interface Props extends GridProps {
  variant?: 'default' | 'success' | 'error' | 'quiz'
  separated?: boolean
}

const styles = (theme: Theme) => {
  const clipPath = `
    polygon(
      0% ${theme.notchSize},
      ${theme.notchSize} 0%,
      calc(100% - ${theme.notchSize}) 0%,
      100% ${theme.notchSize},
      100% calc(100% - ${theme.notchSize}),
      calc(100% - ${theme.notchSize}) 100%,
      ${theme.notchSize} 100%,
      0% calc(100% - ${theme.notchSize})
    )
  `

  return createStyles({
    root: {
      height: 70,
      backgroundColor: theme.palette.grey[50],
      clipPath,
      '-webkit-clip-path': clipPath,
    },
    separated: {
      boxShadow: 'inset 0 1px 0 rgba(0, 0, 0, .1), inset 0 -1px 0 rgba(0, 0, 0, .1)',
    },
    success: {
      backgroundColor: '#F0FFFA',
    },
    error: {
      backgroundColor: '#FFF6F6',
    },
    quiz: {
      height: 'auto',
      minHeight: 70,
      backgroundColor: theme.palette.common.white,
    },
  })
}

type InjectedProps = Props & WithStyles<typeof styles>

const GameCardContent: React.SFC<InjectedProps> = ({
  classes,
  className,
  separated,
  variant,
  ...props
}) => {
  return (
    <Grid
      className={classNames(
        className,
        classes.root,
        {
          [classes.separated]: separated,
          [classes.success]: variant === 'success',
          [classes.error]: variant === 'error',
          [classes.quiz]: variant === 'quiz',
        }
      )}
      direction="row"
      container
      {...props}
    />
  )
}

GameCardContent.defaultProps = {
  variant: 'default'
}

export default withStyles(styles)(GameCardContent)
